export const GET_NUTS_POP = 'GET_NUTS_POP';
export const GET_NUTS_POP2 = 'GET_NUTS_POP2';
export const GET_POP_AQ = 'GET_POP_AQ';
export const GET_POP_AQ2 = 'GET_POP_AQ2';
export const NUTS = 'NUTS';
export const LAU = 'LAU';
export const AQ = 'AQ';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const AGE_GROUPS = 'AGE_GROUPS';
export const GET_LAU_FROM_NUTS = 'GET_LAU_FROM_NUTS';
export const POP_FROM_LAU_AGE = 'POP_FROM_LAU_AGE';
export const AQ_LEVELS = 'AQ_LEVELS';
export const POINT_FROM_LAUCODE = 'POINT_FROM_LAUCODE';
